import { MODULE } from "./consts";
import SalesDashboard from "./SalesDashboard";

export const SalesRoutes = [
  { path: `/${MODULE}`, exact: true, component: SalesDashboard },
];

export default SalesRoutes;
